import React from 'react';
import Container from 'container';
import Headline from 'headline';
import s from './cohort-hero.module.scss';

export default function CohortHero({ title, greywave, ...props }) {
return (
  <Container gradient greywave={greywave} className={s.root}>
    <div className={s.wrapper}>
      <Headline white h1 html={title} className={s.title} />
    </div>
  </Container>
);
}
